import request from '@/router/axios'
const scope = 'server'


export const loginByUsername = (username, password, code, randomStr) => {
  const grant_type = 'password'

  return request({
    url: '/oauth/token',
    headers: {
      isToken:false,
      'Authorization': 'Basic bWMtYWRtaW46bWNAYWRtaW4='
    },
    method: 'post',
    params: { username, password, randomStr, code, grant_type, scope }
  })
}

export const loginByIdentity = (identity, randomStr) => {
  const grant_type = 'production_sso'

  return request({
    url: '/oauth/token',
    headers: {
      isToken:false,
      'Authorization': 'Basic bWMtYWRtaW46bWNAYWRtaW4='
    },
    method: 'post',
    params: { identity, randomStr, grant_type, scope }
  })
}

export const refreshToken = (refresh_token) => {
  const grant_type = 'refresh_token'
  return request({
    url: '/oauth/token',
    headers: {
      'isToken': false,
      'Authorization': 'Basic bWMtYWRtaW46bWNAYWRtaW4=',
    },
    method: 'post',
    params: { refresh_token, grant_type, scope }
  })
}

export const getUserInfo = () => {
  return request({
    url: '/admin/admin/user/info',
    method: 'get'
  })
}

export const logout = () => {
  return request({
    url: '/auth/token/logout',
    method: 'delete'
  })
}
